import React from "react";
import Routers from "./Routers";
import AuthenticateProvider from "./Context/AuthenticateProvider";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Routers />
      </AuthenticateProvider>
      <ToastContainer
        theme="light"
        autoClose={2000}
        position="top-right"
        toastStyle={{
          textTransform: "capitalize",
          maxWidth: "320px",
          width: "auto"
        }}
      />    </React.Fragment>
  )
}

export default App


